import magma from "refractor/magma";
export default magma;